import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  usageHistory: [],
  tokenPackages: [],
  loading: false,
  skaiCancelLoading: false,
};

const skaiSlice = createSlice({
  name: "skai",
  initialState,
  reducers: {
    setSkaiTokenUsage: (state, action) => {
      state.usageHistory = action.payload;
    },
    resetSkaiState: () => initialState,
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setTokenPackages: (state, action) => {
      state.tokenPackages = action.payload;
    },
    setSkaiLoading: (state, action) => {
      state.loading = action.payload;
    },
    setCancelSkaiLoading: (state, action) => {
      state.skaiCancelLoading = action.payload;
    },
  },
});

export const {
  setSkaiTokenUsage,
  resetSkaiState,
  setLoading,
  setSkaiLoading,
  setTokenPackages,
  setCancelSkaiLoading
} = skaiSlice.actions;
export default skaiSlice.reducer;
